import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { getRandomJob, reset } from '../features/job/jobSlice';
import Job from '../components/Job';
import Place from '../components/Place';
import { Col, Container, Row } from 'react-bootstrap';
import Thing from '../components/Thing';
import Emotion from '../components/Emotion';
import Timer from '../components/Timer';

function Dashboard() {
  return (
    <>
      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3486379600176278"
        crossOrigin="anonymous"></script>
      <Container >
        <Row>
          <Col sm>
            <Job />
          </Col>
          <Col sm>
            <Place />
          </Col>
          <Col sm>
            <Thing />
          </Col>
        </Row>
        <Row sm>
          <Col sm>
            <Emotion />
          </Col>
          <Col sm>
            <Timer />
          </Col>
          <Col sm>

            {/* <Row as={Link} to="/gamechanger">TEST</Row> */}
            {/* <Row as={Link} to="/timer">TIMER</Row> */}
          </Col>
        </Row>
        <hr />
      </Container>
    </>
  );
}

export default Dashboard;
